import { combineReducers } from 'redux';
import { createReducer } from '@mews/framework/redux';
import {
    FETCH_EXCHANGE_RATES_FAILED,
    FETCH_EXCHANGE_RATES_STARTED,
    FETCH_EXCHANGE_RATES_SUCCEEDED,
} from './actionTypes';

const DATA_INITIAL_STATE = {};
const META_INITIAL_STATE = {};

const dataReducer = createReducer(DATA_INITIAL_STATE, {
    [FETCH_EXCHANGE_RATES_SUCCEEDED]: (
        state: $TSFixMe,
        { sourceCurrencyCode, enterpriseId, enterpriseExchangeRates, platformExchangeRates }: $TSFixMe
    ) => {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const prevCurrencyCodes = state?.[enterpriseId]?.currencyCodes || [];
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const prevEnterpriseExchangeRates = state?.[enterpriseId]?.enterpriseExchangeRates || [];
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const prevPlatformExchangeRates = state?.[enterpriseId]?.platformExchangeRates || [];

        return {
            ...state,
            [enterpriseId]: {
                currencyCodes: [...prevCurrencyCodes, sourceCurrencyCode],
                enterpriseExchangeRates: [...prevEnterpriseExchangeRates, ...enterpriseExchangeRates],
                platformExchangeRates: [...prevPlatformExchangeRates, ...platformExchangeRates],
            },
        };
    },
});

const updateMeta =
    ({ hasFailed, isFetching }: $TSFixMe) =>
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    (state, { enterpriseId, sourceCurrencyCode }: $TSFixMe) => ({
        ...state,

        [enterpriseId]: {
            ...state[enterpriseId],
            [sourceCurrencyCode]: {
                hasFailed,
                isFetching,
                enterpriseId,
                sourceCurrencyCode,
            },
        },
    });

const metaReducer = createReducer(META_INITIAL_STATE, {
    [FETCH_EXCHANGE_RATES_STARTED]: updateMeta({ hasFailed: false, isFetching: true }),
    [FETCH_EXCHANGE_RATES_SUCCEEDED]: updateMeta({ hasFailed: false, isFetching: false }),
    [FETCH_EXCHANGE_RATES_FAILED]: updateMeta({ hasFailed: true, isFetching: false }),
});

export const exchangeRates = combineReducers({
    data: dataReducer,
    meta: metaReducer,
});
